import React, {Component} from "react";
import HeaderComponentOpenData from "../../components/open_data/HeaderComponentOpenData";

export class HeaderOpenData extends Component{
    render(){
        return(
            <HeaderComponentOpenData />
        )
    }
}

export default HeaderOpenData;